<template>
  <div class="header">
    <div class="progress-bar">
      <div class="progress" v-bind:style="{width: `${remainingTimePercentage}%`}"></div>
    </div>
    <div class="level">Level {{level}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "level",
      "levelTime",
      "elapsedTime",
      "remainingTimePercentage"
    ])
  }
};
</script>

<style scoped>
.header {
  display: flex;
  width: 300px;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
}
.level {
  transition: 0.3s;
  color: var(--color);
  margin-left: 20px;
}

.progress-bar {
  flex-grow: 1;
  height: 20px;
  border-radius: 5px;
  border: 2px solid var(--color);
  transition: 0.3s;
}

.progress {
  height: 100%;
  background: var(--color);
  transition: 0.3s;
}
</style>
